import {Component, OnInit} from "@angular/core";
import {
    FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {FILE_UPLOAD_DIRECTIVES, FileUploader} from "ng2-file-upload";
import {ClientService} from "../../service/client.service";
import {Vehicle} from "../../domain/vehicle";
import {Contract} from "../../domain/contract";
import {ProcedureType} from "../../domain/procedureType";
import {ProcedureService} from "../../service/procedure.service";
import {CUIT_VALIDATOR, DEFAULT_ERROR_MESSAGES, FILE_MAX_SIZE} from "../../validators/validators";
import {ExpirationType} from "../../domain/expirationType";
import {Procedure} from "../../domain/procedure";
import {SendRequestProcedureForm} from "../../domain/sendRequestProcedureForm";
import {LoginService} from "../../service/login.service";
import {User} from "../../domain/user";

@Component({
    selector: 'client-request-procedure',
    template: require('./requestProcedure.component.html'),
    styles: [require('./requestProcedure.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS]
})

export class RequestProcedureComponent implements OnInit {

    public loading: boolean;
    public showVehicle: boolean;
    public successMessage: string;
    public errorMessage: string;
    public errorMessages: any;

    public form: FormGroup;
    public contract: Contract;
    public vehicles: Vehicle[];

    public newProcedure: Procedure;
    public procedureTypeSelected: ProcedureType;
    public procedureType: ProcedureType[];

    //Requisitos para la Solicitud del Tramite
    public uploaderTitle: FileUploader;
    public uploaderDNI: FileUploader;
    public uploaderGreenCard: FileUploader;
    public uploaderOther: FileUploader;
    public hasTitleDropZoneOver: boolean;
    public hasDNIDropZoneOver: boolean;
    public hasGreenCardDropZoneOver: boolean;
    public hasOtherDropZoneOver: boolean;

    public sendRequestProcedure: SendRequestProcedureForm;

    private userLogged : User;
    private vehicle: Vehicle;

    constructor(private clientService: ClientService,
                private procedureService: ProcedureService,
                private loginService: LoginService) {
        this.init();
    }

    private init() {
        this.loading = false;
        this.showVehicle = false;
        this.errorMessages = DEFAULT_ERROR_MESSAGES;
        this.newProcedure = new Procedure();
        this.uploaderTitle = new FileUploader({});
        this.uploaderDNI = new FileUploader({});
        this.uploaderGreenCard = new FileUploader({});
        this.uploaderOther = new FileUploader({});
        this.hasTitleDropZoneOver = false;
        this.hasDNIDropZoneOver = false;
        this.hasGreenCardDropZoneOver = false;
        this.hasOtherDropZoneOver =false;

        this.sendRequestProcedure = new SendRequestProcedureForm();

        this.vehicle = new Vehicle();

    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();

        this.createFormGroup();

        if(this.userLogged.cuit) {
            this.sendRequestProcedure.cuitNumber = this.userLogged.username;
        } else {
            this.sendRequestProcedure.vehicleId = this.userLogged.username;
            this.showVehicle = true;
        }

        this.find();

        this.procedureService.generateProcedureTempId()
            .subscribe(
                (response)=> {
                    this.sendRequestProcedure.tempId = response.value;
                    this.updateUploadersUrl();
                },
                () => {
                    this.bindError('Ocurrió un error al crear la solicitud de trámite.');
                });
    }

    private updateUploadersUrl(): void {

        let fileOwnerId = this.sendRequestProcedure.tempId;

        this.uploaderTitle = new FileUploader({
            url: 'client/' + fileOwnerId + '/upload/TITLE',
            autoUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        });

        this.uploaderDNI = new FileUploader({
            url: 'client/' + fileOwnerId + '/upload/DNI',
            autoUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        });

        this.uploaderGreenCard = new FileUploader({
            url: 'client/' + fileOwnerId + '/upload/GREEN_CARD',
            autoUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        });

        this.uploaderOther = new FileUploader({
            url: 'client/' + fileOwnerId + '/upload/OTHER',
            autoUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        })
    }

    private createFormGroup() {

        if(this.userLogged.cuit) {
            this.form = new FormGroup({
                cuitNumber: new FormControl('', [Validators.required]),
                vehicleId: new FormControl('', [Validators.required]),
                newProcedureType: new FormControl(this.newProcedure.type, [Validators.required]),
                newProcedureDescription: new FormControl(this.newProcedure.description),
            });
        } else if(this.userLogged.patent) {
            this.form = new FormGroup({
                cuitNumber: new FormControl('', [Validators.required, CUIT_VALIDATOR]),
                patent: new FormControl('', [Validators.required]),
                newProcedureType: new FormControl(this.newProcedure.type, [Validators.required]),
                newProcedureDescription: new FormControl(this.newProcedure.description),
            });
        }
    }

    public find(): void {
        this.clearMessages();
        this.getData();
    }

    private getData() {
        this.loading = true;
        this.errorMessage = null;

        if (this.sendRequestProcedure.cuitNumber) {
            this.clientService.getVehiclesByCUIT(this.sendRequestProcedure.cuitNumber).subscribe((data) => {
                        this.vehicles = data;

                        if (this.vehicles.length > 0) {
                            this.showVehicle = true;
                        }
                    },
                    () => {
                        this.bindError('Ocurrió un error al obtener los vehículos asociados al CUIT.');
                    });
        }

        this.procedureService.getProcedureTypes().subscribe((data) => {
            this.setData(data);
        })
    }

    public setData(data: any): void {
        this.loading = false;
        this.procedureType = data;

        this.procedureType = this.procedureType.filter(
            function (obj: ProcedureType) {
                return obj.name == 'GREEN_CARD' ||
                    obj.name == 'BLUE_CARD' ||
                    obj.name == 'OTHER' ||
                    obj.name == 'PLATE_DUPLICATED' ||
                    obj.name == 'TITLE_DUPLICATED';
            });
    }

    public checkNotValid(): boolean {

        return false;

        //TODO: En caso de que los documentos sean obligatorios
        /*
        if (this.newProcedure.type.name == 'GREEN_CARD' && this.uploaderTitle.queue.length == 1)
            return false;
        else if (this.newProcedure.type.name == 'BLUE_CARD' && this.uploaderTitle.queue.length == 1 && this.uploaderDNI.queue.length == 1)
            return false;
        else if (this.newProcedure.type.name == 'TITLE_DUPLICATED' && this.uploaderGreenCard.queue.length == 1)
            return false;
        else if (this.newProcedure.type.name == 'PLATE_DUPLICATED' && this.uploaderTitle.queue.length == 1)
            return false;
        else if (this.newProcedure.type.name == 'OTHER' && this.uploaderOther.queue.length == 1)
            return false;

        return true;
        */
    }

    public procedureTypeChange(newValue: any): void {

        //Si cambio de tramite, tengo que volver a cargar documentos necesarios. Eliminando los ya cargados
        //Evitamos el caso de cambiar a un tipo de tramite que no requiere dicho documento previamente cargado
        this.uploaderTitle.clearQueue();
        this.uploaderDNI.clearQueue();
        this.uploaderGreenCard.clearQueue();
        this.uploaderOther.clearQueue();
        this.clearMessages();

        let result = this.procedureType.filter(function (obj: ExpirationType) {
            return obj.id == newValue;
        });
        if (result.length > 0) {
            this.newProcedure.type = result[0];
            this.sendRequestProcedure.procedureType = result[0].description;
        }
    }

    public send(): void {
        this.loading = true;
        this.clearMessages();

        this.clientService.sendRequestProcedure(this.sendRequestProcedure).subscribe(
            () => {
                this.loading = false;
                this.successMessage = 'La solicitud se envió con éxito.';
                this.clearInputs();
                this.updateAfterSave();
            },
            () => {
                this.bindError('Ocurrió un error al enviar la solicitud.');
            });
    }

    private updateAfterSave(): void {

        this.procedureService.generateProcedureTempId()
            .subscribe(
                (response)=> {
                    this.sendRequestProcedure.tempId = response.value;
                    this.updateUploadersUrl();
                },
                () => {
                    this.bindError('Ocurrió un error al crear la solicitud de trámite.');
                });
    }

    private clearInputs(): void {

        this.procedureTypeSelected = null;
        this.contract = null;
        this.newProcedure = new Procedure();

        this.sendRequestProcedure.comments = '';

        if(this.userLogged.patent)
            this.sendRequestProcedure.cuitNumber = '';

        this.uploaderTitle.clearQueue();
        this.uploaderDNI.clearQueue();
        this.uploaderGreenCard.clearQueue();
        this.uploaderOther.clearQueue();


    }

    public removeTitleFromQuee(item: any): void {
        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'TITLE').subscribe(
            (result) => this.uploaderTitle.removeFromQueue(item),
            () => {
                this.bindError('Ocurrió un error al remover el título.')
            });
    }

    public removeDNIFromQuee(item: any): void {
        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'DNI').subscribe(
            (result) => this.uploaderDNI.removeFromQueue(item),
            () => {
                this.bindError('Ocurrió un error al remover la copia del DNI.')
            });
    }

    public removeGreenCardFromQuee(item: any): void {
        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'GREEN_CARD').subscribe(
            (result) => this.uploaderGreenCard.removeFromQueue(item),
            () => {
                this.bindError('Ocurrió un error al remover el escaneo de la cédula verde.')
            });
    }

    public removeOtherFromQuee(item: any): void {
        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'OTHER').subscribe(
            (result) => this.uploaderOther.removeFromQueue(item),
            () => {
                this.bindError('Ocurrió un error al remover el documento.')
            });
    }

    public fileOverTitle(e: any): void {
        this.hasTitleDropZoneOver = e;
    }

    public fileOverDNI(e: any): void {
        this.hasDNIDropZoneOver = e;
    }

    public fileOverGreenCard(e: any): void {
        this.hasGreenCardDropZoneOver = e;
    }

    public fileOverOther(e: any): void {
        this.hasOtherDropZoneOver = e;
    }

    private bindError(messageError: string): void {
        if (this.errorMessage == null
        ) {
            this.errorMessage = messageError;
        }
        else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.errorMessage = null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/client/requestProcedure/requestProcedure.component.ts
 **/